import { gql } from 'graphql-request'

// Profile image is fetched separately via meProfileImageQuery to avoid blocking
// the initial me query. Signed URL generation takes ~1400ms which would delay
// the entire page load if included here.
export const meQuery = gql`
  query Me {
    me {
      id
      email
      firstName
      lastName
      phone
      staffUserPermissions
      favoriteSiteIds
      favoriteReportNames
      favoriteSavedReportIds
      type
    }
  }
`

export const meProfileImageQuery = gql`
  query MeProfileImage($type: ImageSupportedVariant!, $format: ImageFileVersionFormat!) {
    me {
      profileImage(input: { type: $type, format: $format }) {
        url
        type
        width
        height
      }
    }
  }
`

export const toggleSiteFavoriteMutation = gql`
  mutation ToggleSiteFavorite($siteId: UUID!) {
    me {
      toggleSiteFavorite(siteId: $siteId)
    }
  }
`

export const toggleFavoriteReportMutation = gql`
  mutation ToggleFavoriteReport($reportName: String!) {
    me {
      toggleFavoriteReport(reportName: $reportName)
    }
  }
`

export const toggleFavoriteSavedReportMutation = gql`
  mutation ToggleFavoriteSavedReport($savedReportId: String!) {
    me {
      toggleFavoriteSavedReport(savedReportId: $savedReportId)
    }
  }
`
